import * as React from 'react';

import { ImageWithFallback } from '@blockworks/ui/image-with-fallback';
import { RenderSimpleHtml } from '@blockworks/ui/legacy/string';

import { SpeakerEndpointResult } from '@/utils/functions/wordpress/fetch-speakers';

type SpeakerPageLayoutProps = {
    speaker: SpeakerEndpointResult;
};

const SpeakerPageLayout = (props: SpeakerPageLayoutProps) => {
    const { speaker } = props;

    return (
        <main className="w-full">
            <div className="flex flex-col md:flex-row justify-start items-center lg:items-start self-stretch flex-grow-0">
                <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 bg-[color:#f8b4e4]">
                    {speaker.thumbnail && (
                        <ImageWithFallback
                            alt={speaker.title || ''}
                            src={speaker.thumbnail}
                            width={475}
                            height={475}
                            className="object-cover md:max-h-[600px]"
                        />
                    )}
                </div>
                <div className="flex flex-col justify-start items-start self-stretch flex-grow">
                    <div className="flex flex-col justify-end items-start self-stretch flex-grow relative gap-1 p-10 bg-[color:#000a39]">
                        <p className="self-stretch flex-grow-0 flex-shrink-0 w-full text-5xl text-left text-white">
                            {speaker.title}
                        </p>
                        <p className="self-stretch flex-grow-0 flex-shrink-0 w-full text-base text-left text-[#e0e3eb]">
                            {speaker.custom_fields?.speaker_company?.value}
                            {speaker.custom_fields?.speaker_company?.value &&
                                speaker.custom_fields?.speaker_job?.value &&
                                ' | '}
                            {speaker.custom_fields?.speaker_job?.value}
                        </p>
                    </div>
                    <div className="hidden lg:flex flex-col justify-end items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3 p-10 bg-[color:#f7f7f7]">
                        <p className="self-stretch flex-grow-0 flex-shrink-0 w-full text-lg text-left">
                            <RenderSimpleHtml html={speaker.description || ''} />
                        </p>
                    </div>
                </div>
            </div>
            <div className="lg:hidden flex flex-col justify-end items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3 p-10 bg-[color:#f7f7f7]">
                <p className="self-stretch flex-grow-0 flex-shrink-0 w-full text-lg text-left">
                    <RenderSimpleHtml html={speaker.description || ''} />
                </p>
            </div>
        </main>
    );
};

export default SpeakerPageLayout;
